import { render } from "./BaseAvatar.vue?vue&type=template&id=2f58bfff&scoped=true"
import script from "./BaseAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&lang=js"

import "./BaseAvatar.vue?vue&type=style&index=0&id=2f58bfff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f58bfff"]])

export default __exports__